import {supplementRegexBaseString} from 'client/generic/MarkdownRendererV2/rules/supplementRules';
import {makeParser} from 'generic/MarkdownRendererV2/markdownRendererUtils';
import React from 'react';
import {getMarkdownRenderer} from 'generic/MarkdownRendererV2/markdownRendererRef';

export const isSupplement = (value: string) => {
  const regex = new RegExp(supplementRegexBaseString);
  return regex.test(value);
};

/**
 * Extracts the supplement token and any surrounding plain text from a value string.
 * Returns null if the value contains no supplement.
 */
export const extractSupplementParts = (
  value: string
): {supplementToken: string; text: string} | null => {
  const regex = new RegExp(supplementRegexBaseString);
  const match = value.match(regex);
  if (!match) return null;
  return {
    supplementToken: match[0],
    text: value.replace(match[0], '').trim()
  };
};

const getSupplementRenderer = (value: string) => {
  const parser = makeParser();
  const syntaxTree = parser.makeSyntaxTree(value);
  return parser.reactOutput(syntaxTree);
};

export const renderStringOrSupplement = (value: string) => {
  if (isSupplement(value)) {
    return getSupplementRenderer(value);
  }
  const MarkdownRendererV2 = getMarkdownRenderer();
  return <MarkdownRendererV2 text={value} />;
};
